/* global _, $, Rx, virtualDom, Promise, ProgressBar, console */
import {convertName, getFabs} from "./_utilities";
const h = virtualDom.h;

/**
 * Build truck configurator
 * @param selector - dom selector for container
 * @param path - path to the images
 * @param layers - array of layerNames
 * @param useWorker - bool
 * @returns {*|jQuery|HTMLElement}
 */
export function setupExteriorBuilder(selector, state, l, useWorker) {
	let exteriorBuilder = {},
		path = convertName(state.truckModel + "-" + state.truckCab) + "-exterior",
		$container = $(selector),
		$layers = $('<div class="layers"></div>').appendTo($container),
		imageLayers = [],
		$progressBarMask = $('<div class="progress-bar-mask"><div class="progress-bar-wrap"><div class="progress-bar-circle"></div></div></div>').appendTo($container),
		$progressBarCircle = new ProgressBar.Circle($progressBarMask.find(".progress-bar-circle")[0], {
			color: "#fff",
			// This has to be the same size as the maximum width to
			// prevent clipping
			strokeWidth: 4,
			trailWidth: 4,
			easing: 'easeInOut',
			duration: 1400,
			svgStyle: {
				display: 'block',
				width: '100%',
				height: '100%',
				position: 'absolute'
			},
			text: {
				autoStyleContainer: false
			},
			from: {color: '#e5e5e5', width: 4},
			to: {color: '#5482ab', width: 4},
			// Set default step function for all animate calls
			step: function (state, circle) {
				circle.path.setAttribute('stroke', state.color);
				circle.path.setAttribute('stroke-width', state.width);

				var value = Math.round(circle.value() * 100);
				if (value === 0) {
					circle.setText('');
				} else {
					circle.setText("LOADING " + value + "%");
				}

			}
		}),
		$progressBarLineWrap = $('<div class="progress-bar-wrap remainder"><div class="progress-bar-line"></div></div></div>').appendTo($container),
		$progressBarLine = new ProgressBar.Line($progressBarLineWrap.find(".progress-bar-line")[0], {
			strokeWidth: 4,
			easing: 'linear',
			duration: 1400,
			color: '#5482ab',
			trailColor: '#e5e5e5',
			trailWidth: 4,
			svgStyle: {width: '100%', height: '100%'}
		}),
		imageMaxWidth = 1365,
		imageMaxHeight = 910,
		aspectRatio = imageMaxHeight / imageMaxWidth,
		numFrames = 24,
		frameDivider = 1,
		dragSpeedFactor = 0.08,
		minScrubDistance = 40,
		dimensionsRegex = /-(\d+)-(\d+)-(\d+)-(\d+).png/g,
		layersVTree, layersVNode;

	exteriorBuilder.el = $container;


	/**
	 *
	 * @param n - the number to pad
	 * @param p - pad amount
	 * @param c - pad character (default: 0)
	 * @returns {string}
	 */
	function anglePad(n, p, c) {
		var pad_char = typeof c !== 'undefined' ? c : '0';
		var pad = new Array(1 + p).join(pad_char);
		return (pad + n).slice(-pad.length);
	}

	function filterByDivider(_, i) {
		return i % frameDivider < 1;
	}

	function loadImage(image) {
		return new Promise((resolve, reject) => {
			let img = new Image();
			img.src = image;
			img.onload = () => {
				// console.log("resolve load Image", image.src)
				resolve(image);
			};
		});
	}

	function sortImages(a, b) {
		var srcA = a.toUpperCase(); // ignore upper and lowercase
		var srcB = b.toUpperCase(); // ignore upper and lowercase
		if (srcA < srcB) {
			return -1;
		}
		if (srcA > srcB) {
			return 1;
		}
		// names must be equal
		return 0;
	}

	function getCanvasDimensions() {
		var width = $container.find(".layers").outerWidth(),
			height = $container.find(".layers").outerHeight();
		if (width * aspectRatio < height) {
			return {
				width: width,
				height: width * aspectRatio
			};
		} else {
			return {
				width: height / aspectRatio,
				height: height
			};
		}
	}


	function delegate(wrapper, selector, eventName) {
		return Rx.Observable.fromEvent(
			wrapper,
			eventName,
			function (e) {
				return {event: e, delegate: e.target.closest(selector)};
			}
		).filter(function (x) {
			return x.delegate !== null;
		});
	}

	function setupKeyControls($layers) {
		Rx.Observable.fromEvent(document, "keydown").subscribe(function (e) {
			var movement = 1 * frameDivider / numFrames,
				direction,
				progress;
			if (e.keyCode === 37 || e.keyCode === 39) {
				e.preventDefault();
				direction = 38 - e.keyCode;
				rotateTruck(direction);
			}
		});
	}

	/**
	 *
	 * @param x
	 * @param y
	 * @param canvasDims
	 * @returns {{left: string, top: string}}
	 */
	function getHotspotScaledPosition(x, y, canvasDims) {
		let position = {
			left: (((x / state.hotspotScaleWidth) * canvasDims.width) >> 0) + "px",
			top: (((y / state.hotspotScaleHeight) * canvasDims.height) >> 0) + "px"
		};
		return position;
	}

	/**
	 *
	 * @param layerContainer
	 * @param state
	 */
	function buildDom(layerContainer, state) {
		// insert/update image layers
		let canvasDims = getCanvasDimensions(),
			vdom = h("div", [
				h("button.view-hotspots", "View Features"),
				h("div.vdom", {
					attributes: {
						"style": "width: " + canvasDims.width + "px;" +
						" height: " + canvasDims.height + "px;"
					}
				}, [
					layerContainer
				])
			]);

		if (layersVTree) {
			let newLayersVTree = vdom, // with some munging
				layersPatches = virtualDom.diff(layersVTree, newLayersVTree);
			layersVNode = virtualDom.patch(layersVNode, layersPatches);
			layersVTree = newLayersVTree;
		} else {
			layersVTree = vdom;
			layersVNode = virtualDom.create(layersVTree);
			$layers.html(layersVNode);
		}
	}

	/**
	 * get image data and dims
	 * @param src
	 * @returns {Promise}
	 */
	function getImage(src) {
		let p = new Promise((resolve, reject) => {
			var img = new Image(),
				dims;
			img.crossOrigin = "";
			img.src = src;
			dims = getDimensions(src);
			img.onload = function () {
				resolve({
					src,
					img,
					dims
				});
			};
			img.onerror = (e) => {
				resolve();
			};
		});
		return p;
	}

	function createLayerGenerator(state, numAngles) {
		let images = _.times(numAngles, i => {
			return "/images/configurator-mini/" + path + "/" +
				convertName(state.truckModel + "-" + state.truckCab) +
				"-cab-" +
				anglePad(i * 360 / numFrames, 3) + ".jpg";
		});

		return Rx.Observable.from(images).mergeMap(image => {
			return Rx.Observable.fromPromise(loadImage(image));
		}).scan((a, x, i) => {
			updateProgress(i, images.length - 1, x, false, false);
			return x;
		}).bufferCount(numAngles.length)

	}

	function updateHotspotPositions() {
		let canvasDims = getCanvasDimensions();
		$container.find(".hotspot-label").each((i, spot) => {
			let $spot = $(spot),
				data = $spot.data("fab"),
				x = data.fabPosition.x,
				y = data.fabPosition.y,
				scaledPosition = getHotspotScaledPosition(x, y, canvasDims);
			$spot.css({
				left: scaledPosition.left,
				top: scaledPosition.top
			});
		});
	}

	function generateHotspots(state) {
		// create hotspots
		$container.find(".hotspot-label").remove();

		_.chain(getFabs(state)).forEach(fab => {
			let canvasDims = getCanvasDimensions(),
				hotspotPosition = getHotspotScaledPosition(fab.fabPosition.x, fab.fabPosition.y, canvasDims),
				$vdom = $layers.find(".vdom");
			$('<div class="hotspot-label"></div>')
				.data({
					"data-fab": fab
				})
				.attr({
					"data-fab": JSON.stringify(fab),
					"style": "left: " + hotspotPosition.left + "; top: " + hotspotPosition.top + ";"
				}).appendTo($vdom);
		}).value();
	}

	function updateTruckRotation(state) {
		if (!exteriorBuilder.rotationAngle || state.exteriorBuildChange.Pillar) {
			rotateTruck(false, state.hotspotAngle);
		} else {
			rotateTruck(false, exteriorBuilder.rotationAngle);
		}
	}

	exteriorBuilder.update = (state) => {
		if (state.truckModel === "" || state.truckCab === "") {
			$layers.hide();
			return;
		}

		$layers.show();
		// console.log("start creating layers");

		if (state.actionType === "cab_change") {
			exteriorBuilder.rotationAngle = false;
		}

		if (state.actionType !== "pillar_change") {
			// hide everything until done building
			$layers.css({
				opacity: 0
			});
			updateProgress(1, 100, null, false, false);
		}


		path = convertName(state.truckModel + "-" + state.truckCab) + "-exterior";

		// let observables = createLayerGenerator(state, numFrames);

		createLayerGenerator(state, numFrames)
			.subscribe(function (images) {
				// console.log("done creating layers", images);

				let layerContainer = h("div.image-layer", _.chain(images).sort(sortImages).map(img => {
					return h("img.layer-angle", {
						src: img
					});
				}).value());
				buildDom(layerContainer, state);

				generateHotspots(state);

				updateTruckRotation(state);

				// updateHotspotPositions();

				// show everything now it's done building
				$layers.css({
					opacity: 1
				});
				updateProgress(1, 1, null, true, false);

			}, function error(e) {
				console.log("error", e);
			});


	};

	// setup truck spin animations
	/**
	 *
	 * @param $layerContainer
	 * @param $mouseContainer
	 */
	function initScrubAnimationEvents($layers, $mouseContainer) {
		var $window = $(window),
			winWidth = $window.width(),
			$mContainer = $mouseContainer || $layers,
			isDragging = false,
			startX,
			lastX,
			direction = 0;

		function handleStart(e) {
			e.preventDefault();
			isDragging = true;
			let touch = e.originalEvent.touches,
				x = touch ? e.originalEvent.touches[0].pageX : e.pageX;
			startX = x;
			lastX = x;
		}

		function handleEnd(e) {
			isDragging = false;
			startX = 0;
			lastX = 0;
		}

		function handleMove(e) {
			let movement,
				currentDirection,
				touch = e.originalEvent.touches,
				x = touch ? e.originalEvent.touches[0].pageX : e.pageX;

			if (isDragging) {
				// check for direction
				// if changed reset starting point for computing progress
				currentDirection = x - lastX > 0 ? -1 : 1;
				if (direction !== currentDirection) {
					startX = x;
					direction = currentDirection;
				}
				winWidth = $window.width();
				movement = Math.abs(x - startX) > minScrubDistance; //Math.abs((e.pageX - startX) * dragSpeedFactor);
				// console.log("movement", movement, startX, e.pageX, lastX);
				if (movement) {
					rotateTruck(direction);
					startX = x;
				}
				lastX = x;
			}
		}

		Rx.Observable.fromEvent($mContainer, "mousedown").subscribe(handleStart);
		Rx.Observable.fromEvent($mContainer, "mouseup").subscribe(handleEnd);
		Rx.Observable.fromEvent($mContainer, "mousemove").subscribe(handleMove);
		Rx.Observable.fromEvent($mContainer, "touchstart").subscribe(handleStart);
		Rx.Observable.fromEvent($mContainer, "touchend").subscribe(handleEnd);
		Rx.Observable.fromEvent($mContainer, "touchmove").subscribe(handleMove);
	}

	function showActiveLayer(hideIndex, showIndex) {
		$layers.find(".image-layer, .paint-layer").each((i, layer) => {
			let angles = $(layer).find(".layer-angle");
			angles.eq(hideIndex).css({
				opacity: 0
			});
			angles.eq(showIndex).css({
				opacity: 1
			});
		});
	}

	function wrapIndex(index) {
		let wrappedIndex;
		if (index === numFrames) {
			wrappedIndex = 0
		} else if (index === -1) {
			wrappedIndex = numFrames - 1;
		} else {
			wrappedIndex = index;
		}
		return wrappedIndex
	}

	function angleToIndex(angle) {
		return (angle / 360) * numFrames >> 0;
	}

	function rotateTruck(d, targetRotationAngle, fps = 10) {
		let currentRotationIndex = angleToIndex(exteriorBuilder.rotationAngle),
			targetRotationIndex = targetRotationAngle ?
				angleToIndex(targetRotationAngle) :
			currentRotationIndex + (d ? d : 0),
			direction = d || 0,
			showIndex;

		// if all angles haven't been loaded yet then just show first one
		if (numFrames !== 24) {
			currentRotationIndex = currentRotationIndex;
		}

		if (!d) {
			// if all angles haven't been loaded yet then just show first one
			if (numFrames !== 24) {
				targetRotationIndex = 0;
			}
			if (targetRotationIndex > currentRotationIndex) {
				if (targetRotationIndex - currentRotationIndex > numFrames / 2) {
					direction = -1;
				} else {
					direction = 1;
				}
			} else if (currentRotationIndex > targetRotationIndex) {
				if (currentRotationIndex - targetRotationIndex > numFrames / 2) {
					direction = 1;
				} else {
					direction = -1;
				}
			} else {
				direction = 0;
			}
		}

		showIndex = wrapIndex(currentRotationIndex + direction);
		showActiveLayer(currentRotationIndex, showIndex);

		// console.log("indices", currentRotationIndex, targetRotationIndex, numFrames);
		// console.log("exteriorBuilder.rotationAngle", exteriorBuilder.rotationAngle);
		// console.log("targetRotationAngle", targetRotationAngle);
		// console.log("targetRotationIndex", targetRotationIndex);
		// console.log("layer to hide", currentRotationIndex);
		// console.log("layer to show", showIndex);

		// store new rotation angle
		// and show hotspots if we are at the right angle
		exteriorBuilder.rotationAngle = numFrames ? showIndex * 360 / numFrames : 0;
		if (exteriorBuilder.rotationAngle !== state.hotspotAngle) {
			$container.find(".hotspot-label").hide();
			$container.find(".view-hotspots").show();
		} else {
			$container.find(".hotspot-label").show();
			$container.find(".view-hotspots").hide();
		}

		// continue if we have not reached newRotationAngle
		if (showIndex !== targetRotationIndex) {
			setTimeout(function () {
				rotateTruck(false, targetRotationAngle);
			}, 1000 / fps);
		}
	}

	function updateProgress(i, l, x, c, r, min = 0, max = 1) {
		var target = l > 0 ? l : 1,
			progress = min + ((i / target) * max);
		// console.log("update progress: ", i, l, min, max, progress, c, r);

		if (r) {
			if (progress >= 0) {
				$progressBarLineWrap.show();
			}
			$progressBarLine.animate(progress);
			if (c) {
				$progressBarLineWrap.hide();
				$progressBarLine.set(0);
			}
		} else {
			if (progress >= 0) {
				$progressBarMask.show();
			}

			$progressBarCircle.animate(progress);
			if (c) {
				$progressBarMask.hide();
				$progressBarCircle.set(0);
			}
		}
		return {
			current: x,
			progress: progress,
			r
		};
	}

	initScrubAnimationEvents($layers, $container);
	setupKeyControls($layers);

	return exteriorBuilder;
}
